<template>
    <section class="communicationDetail">
        <dotLoader v-if="this.isLoading || this.isPostLoading || this.isDeleteLoading || this.isReactionLoading"></dotLoader>
        <leftMenu />
        <page-header icon="newspaper-outline" :headerProps="this.headerProps"/>

        <section id="mainContent" v-if="!this.isLoading">
            <div class="annoucement-box">
                <div v-if="this.userNoticeType === 2" class="urgency-box">Urgente</div>
                <span  class="annoucement-content" v-html="this.annoucementContent"></span>
                <div class="reactions-row" v-if="this.canReact">
                    <div class="reaction-wrapper">
                        <div :class="[{'actived-reaction': userSelectedReaction === 5}, 'unactive-reaction']">
                            <img src="../../../../assets/img/reactions/-1.svg"  @click="addReaction(5)" >
                        </div>
                        <div :class="[{'text-bot-active': userSelectedReaction === 5}, 'reaction-text-box']">
                            {{ $t("Não Gostei") }}
                        </div>
                        <div v-if="this.reactCount.dislike !== 0" class="reaction-counter">
                            {{ this.reactCount.dislike }}
                        </div>
                        <div class="not-displayed" v-else>&nbsp;</div>
                    </div>
                    <div class="reaction-wrapper">
                        <div :class="[{'actived-reaction': userSelectedReaction === 1}, 'unactive-reaction']">
                            <img src="../../../../assets/img/reactions/thumbs_up.svg" @click="addReaction(1)">
                        </div>
                        <div :class="[{'text-bot-active': userSelectedReaction === 1}, 'reaction-text-box']">
                            {{ $t("Gostei") }}
                        </div>
                        <div v-if="this.reactCount.like !== 0" class="reaction-counter">
                            {{ this.reactCount.like }}
                        </div>
                        <div class="not-displayed" v-else>&nbsp;</div>
                    </div>

                    <div class="reaction-wrapper">
                        <div :class="[{'actived-reaction': userSelectedReaction === 4}, 'unactive-reaction']">
                            <!-- <img src="../../../../assets/img/reactions/white_check_mark.svg" > -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" @click="addReaction(4)">
                                <path d="M24.929 1.49158H3.26237C2.34154 1.49158 1.5957 2.23741 1.5957 3.15824V24.8249C1.5957 25.7457 2.34154 26.4916 3.26237 26.4916H24.929C25.8499 26.4916 26.5957 25.7457 26.5957 24.8249V3.15824C26.5957 2.23741 25.8499 1.49158 24.929 1.49158Z" fill="#689F38"/>
                                <path d="M23.6165 1.49158H3.15821C2.29779 1.49783 1.60196 2.19366 1.59571 3.05408V23.4499C1.59362 24.3124 2.29154 25.0103 3.15404 25.0124C3.15612 25.0124 3.15612 25.0124 3.15821 25.0124H23.5957C24.4582 25.0145 25.1561 24.3166 25.1582 23.4541C25.1582 23.452 25.1582 23.452 25.1582 23.4499V3.05408C25.177 2.21033 24.5061 1.51033 23.6624 1.49158C23.6478 1.49158 23.6311 1.49158 23.6165 1.49158Z" fill="#7CB342"/>
                                <path opacity="0.3" d="M9.0332 3.3457C9.0332 2.86653 8.69987 2.7207 6.7832 2.7832C5.17904 2.8457 4.38737 3.0332 3.9082 3.61653C3.42904 4.19986 3.30404 5.38736 3.2832 6.80403C3.2832 7.80403 3.2832 8.74153 3.80404 8.74153C4.51237 8.74153 4.51237 7.0957 5.0957 6.17903C6.2207 4.36653 9.0332 3.9707 9.0332 3.3457Z" fill="white"/>
                                <path d="M9.67893 23.4707C8.85393 23.4937 8.11434 22.9666 7.86643 22.1791L4.72059 12.6999C4.41643 11.6978 4.98309 10.6374 5.98518 10.3332C6.95393 10.0395 7.98309 10.5582 8.32476 11.5124L10.3664 17.6582L20.1789 5.24157C20.8289 4.41866 22.0227 4.27907 22.8456 4.92907C23.6685 5.57907 23.8081 6.77282 23.1581 7.59574L11.1581 22.7416C10.8018 23.1978 10.2581 23.4666 9.67893 23.4707Z" fill="#FBF9F9"/>
                            </svg>
                        </div>
                        <div :class="[{'text-bot-active': userSelectedReaction === 4}, 'reaction-text-box']">
                            {{ $t("Check") }}
                        </div>
                        <div v-if="this.reactCount.check !== 0" class="reaction-counter">
                            {{ this.reactCount.check }}
                        </div>
                        <div class="not-displayed" v-else>&nbsp;</div>
                    </div>

                    <div class="reaction-wrapper">
                        <div :class="[{'actived-reaction': userSelectedReaction === 2}, 'unactive-reaction']">
                            <img src="../../../../assets/img/reactions/heart.svg" @click="addReaction(2)">
                        </div>
                        <div :class="[{'text-bot-active': userSelectedReaction === 2}, 'reaction-text-box']">
                            {{ $t("Amei") }}
                        </div>
                        <div v-if="this.reactCount.heart !== 0" class="reaction-counter">
                            {{ this.reactCount.heart }}
                        </div>
                        <div class="not-displayed" v-else>   </div>
                    </div>

                    <div class="reaction-wrapper">
                        <div :class="[{'actived-reaction': userSelectedReaction === 3}, 'unactive-reaction']">
                            <img src="../../../../assets/img/reactions/clap.svg" @click="addReaction(3)">
                        </div>
                        <div :class="[{'text-bot-active': userSelectedReaction === 3}, 'reaction-text-box']">
                            {{ $t("Parabéns") }}
                        </div>
                        <div v-if="this.reactCount.applause !== 0" class="reaction-counter">
                            {{ this.reactCount.applause }}
                        </div>
                        <div class="not-displayed" v-else>   </div>
                    </div>
                </div>
                <div class="attach-wrapper">
                  <div v-if="attachments.length" v-for="(file, index) in attachments">
                      <img src="../../../../assets/img/vectors/attach.svg" class="clip-icon">
                      <a :href="file.uri" target="_blank" class="attachment">{{`anexo ${index + 1}`}}</a>
                  </div>
                </div>
            </div>
            <section v-if="!this.isLoading && canComment">
                <div class="comments-title">
                    {{ `Comentários (${this.comments.length})` }}
                </div>
                <div class="page-line" />

                <!-- ESCREVA UM COMENTÁRIO -->
                <form
                    @submit.prevent="sendNewComment()"

                    :class="[{'form-input-comment-active': isTextAreaClicked}, 'form-input-comment']"
                >
                    <div :class="[{'input-comment-wrapper-active': isTextAreaClicked}, 'input-comment-wrapper']">
                        <img :src="userInfo.photo" />
                        <div class="input-comment-inside-wrapper">
                            <textarea
                                :class="[{'textarea-comment-input-active': isTextAreaClicked}, 'textarea-comment-input']"
                                placeholder="Escreva um comentário"
                                v-model="commentBody.comment"
                                ref="textarea"
                                @click="openTextArea()"
                                @input="updateCharacterCount(); resizeTextarea($event)"
                            />
                            <p :class="[{'remaining-characters-active': isTextAreaClicked }, 'remaining-characters']" v-if="charactersRemaining >= 0">{{ charactersRemaining}} caracteres restantes.</p>
                            <p :class="[{'remaining-characters-active': isTextAreaClicked }, 'remaining-characters']" v-else style="color: red;">{{ - charactersRemaining }} caracteres acima do limite!</p>
                            <button
                                :class="[{'send-comment-button-active': isTextAreaClicked}, 'send-comment-button']"
                                type="submit">
                                {{ $t("Comentar") }}
                            </button>
                        </div>
                    </div>
                </form>
                <!-- COMENTÁRIOS -->
                <div v-for="(e, index) in comments"
                    :key="index"
                    class="comment-wrapper"
                >
                    <img v-if="e.userPhoto" :src="e.userPhoto" class="profile-img-ellipse" />
                    <div v-else class="profile-img-ellipse">
                        {{ getNameInitials(e.userName)}}
                    </div>
                    <div class="comment-box">
                        <img src="../../../../assets/img/vectors/Vector 1.svg" class="vector-comment-box">
                        <div class="profile-comment-username">{{ e.userName }}</div>
                        <div class="profile-comment">{{ e.comment }}</div>
                    </div>

                    <div class="comment-date">
                        {{ e.createdAt | formatDateHours }}
                    </div>
                    <img @click="checkRemoveComment(e, index)" v-if="e.userId === userInfo.id" src="../../../../assets/img//vectors/trash-outline.png" class="delete-button">
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import { REQUEST_SERVICE } from '../../../../requestConfig';
import { READ_USER_NOTICE_ATT,
    ADD_COMMENT_COMMUNICATION,
    DELETE_COMMENT_COMMUNICATION,
ADD_REACTION_COMMUNICATION
 } from '../../../../urlConfig';
import { UTIL_SERVICE } from '../../../../utils';
import PageHeader from '../../components/layouts/pageHeader.vue';
import leftMenu from '../../components/leftMenu.vue';
import dotLoader from '../../components/dotLoader.vue';

export default {
    name: 'communication-detail',
    components: {
        PageHeader,
        leftMenu,
        dotLoader
    },
    data() {
        return {
            isTextAreaClicked: false,
            isActive: false,
            isLoading: false,
            isDeleteLoading: false,
            isPostLoading: false,
            isReactionLoading: false,
            headerProps: {
                headerTitle: '',
                filterOrDate: 'date',
                headerContent: {
                    annoucementDate: ''
                }
            },
            annoucementContent: '',
            reactCount: {
                like: 0,
                check: 0,
                applause: 0,
                dislike: 0,
                heart: 0,
            },
            reactionBody: {
                companyStatementReactSelected: '',
                userId: '',
                companyStatementId: this.$route.params.id
            },
            userSelectedReaction: 0,
            comments: [],
            canComment: false,
            canReact: false,
            userInfo: {},
            commentBody: {
                companyStatementId: this.$route.params.id,
                comment: '',
            },
            myReactionSelected: 0,
            userNoticeType: 0,
            attachments: [],
            canSend: false,
            characterCount: 0,
            maxCharacterLimit: 255,
            isDarkModeActive: false,
        }
    },
    methods: {
        getCommunicationDetails() {
            this.isLoading = true;
            REQUEST_SERVICE.get(READ_USER_NOTICE_ATT + this.$route.params.id).then((response) => {
                UTIL_SERVICE.console("RESULT READ_USER_NOTICE_ATT:", response.data);

                this.headerProps.headerTitle = response.data.title;
                this.headerProps.headerContent.annoucementDate = response.data.createdAt;
                this.annoucementContent = response.data.message;
                this.comments = response.data.listComments;
                this.canComment = response.data.canComment;
                this.canReact = response.data.canReact;
                this.userNoticeType = response.data.userNoticeType;
                this.userSelectedReaction = response.data.myReactSelected;
                this.attachments = response.data.attachments;
                this.commentBody.comment = '';
                this.reactCount.check = response.data.reactsCount.goodIdea;
                this.reactCount.dislike = response.data.reactsCount.dislike;
                this.reactCount.applause = response.data.reactsCount.applause;
                this.reactCount.like = response.data.reactsCount.ok;
                this.reactCount.heart = response.data.reactsCount.heart;

                this.isLoading = false;
                this.isPostLoading = false;
            })
        },
        getNameInitials (name) {
            const regex = /\b[A-Za-z]/g;
            const initials = (name.match(regex) || [])
                .map(initial => initial.toUpperCase()).slice(0, 2).join('');
            return initials;
        },
        getUserInfo() {
            const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
            this.userInfo = userInfo;
            this.reactionBody.userId = userInfo.id;
        },
        validateComment() {
            if(this.commentBody.comment.length >= 3 && this.commentBody.comment.length <= 255) {
                return true;
            } else {
                return false;
            }
        },
        sendNewComment() {
            if(this.validateComment()) {
                this.isTextAreaClicked = false;
                if (this.commentBody.comment) {
                    this.isPostLoading = true;
                    UTIL_SERVICE.console("Data send:", this.commentBody);
                    REQUEST_SERVICE.post(ADD_COMMENT_COMMUNICATION, this.commentBody).then((response) => {
                    UTIL_SERVICE.console("ADD_COMMENT_COMMUNICATION:", response.data);

                    this.$toast.success(this.$t("Comentário enviado."), {
                        timeout: 3000,
                        closeOnClick: false,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        closeButton: 'button',
                    });

                    this.getCommunicationDetails();
            }).catch(reason => {
                UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendNewComment', {data: this.commentBody, route: ADD_COMMENT_COMMUNICATION}, true, reason.response.data);

                this.isPostLoading = false;
            });
                }
            } else {
                this.$toast.error(this.$t('O comentário precisa ter no mínimo 3 e no máximo 255 caracteres.'))
            }
        },
        checkRemoveComment(data, index) {
            swal({
                title: this.$t("Atenção"),
                text: this.$t("Você tem certeza que deseja excluir o comentário?"),
                icon: "warning",
                buttons: [this.$t("Cancelar"), this.$t("Excluir")]
            }).then(continueResult => {
            if (continueResult) {
                this.deleteComment(data, index)
            }
            });
        },
        deleteComment(data, index) {
            this.isDeleteLoading = true;
            REQUEST_SERVICE.get(DELETE_COMMENT_COMMUNICATION + data.id).then((response) => {
            UTIL_SERVICE.console("DELETE_COMMENT_COMMUNICATION:", response.data);

            this.isDeleteLoading = false;
            this.$toast.success(this.$t('Comentário deletado.'))
            this.comments.splice(index, 1);
          }).catch(reason => {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'deleteComment', {route: DELETE_COMMENT_COMMUNICATION}, true, reason.response.data);

            this.isDeleteLoading = false;
          });
        },
        addReaction(type) {
            if(!this.isReactionLoading) {
                this.isReactionLoading = true;
                this.reactionBody.companyStatementReactSelected = type;

                UTIL_SERVICE.console("Data sent: ", this.reactionBody)
                REQUEST_SERVICE.post(ADD_REACTION_COMMUNICATION, this.reactionBody).then((response) => {
                    UTIL_SERVICE.console("ADD_REACTION_COMMUNICATION: ", response.data);

                    if (this.userSelectedReaction === type) {
                        this.userSelectedReaction = null;
                    } else {
                        this.userSelectedReaction = type
                    }

                    this.reactCount.like = response.data.ok;
                    this.reactCount.dislike = response.data.dislike;
                    this.reactCount.applause = response.data.applause;
                    this.reactCount.check = response.data.goodIdea;
                    this.reactCount.heart = response.data.heart;
                    this.isReactionLoading = false;
                    })
                }
        },
        openTextArea() {
            this.isTextAreaClicked = true;
        },
        updateCharacterCount() {
            this.characterCount = this.commentBody.comment.length;
        },
        resizeTextarea(e) {
            e.target.style.height = '0';
            e.target.style.height = `${e.target.scrollHeight}px`
        }
    },
    computed: {
        charactersRemaining() {
            return this.maxCharacterLimit - this.characterCount;
        },
        currentRouteName() {
            return this.$route.path;
        }

    },
    beforeMount() {
        this.getCommunicationDetails();
        this.getUserInfo();
    },
    beforeDestroy: function() {

    },
    beforeUpdate() {

    },
    mounted() {
        const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
        homeCtrl.noticeId = this.reactionBody.companyStatementId;
        UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
    }
}
</script>

<style scoped lang="scss">

    .communicationDetail {
        transition: 0.5s;
        background: var(--bodyColor2);

        #mainContent {
            position: relative;
            .annoucement-box {
                border: 1px solid var(--borderGray);
                border-radius: 20px;
                min-height: 143px;
                padding: 21px 15px;
                position: relative;

                .urgency-box {
                    transition: 0.5s;
                    position: absolute;
                    right: 40px;
                    top: -10px;
                    height: 23px;
                    width: 81px;
                    display: flex;
                    padding: 1px 8px 1px 8px;
                    justify-content: center;
                    align-items: center;
                    border-radius: 10px;
                    border: 3px solid var(--border);
                    background: var(--main-red, #FF445D);
                    color: #fff;
                    font-size: 13px;
                }

                .attach-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    justify-items: center;
                    position: absolute;
                    bottom: -28px;
                    left: 0px;
                    gap: 8px;

                    .clip-icon {
                        width: 18px;
                        height: 18px;
                        color: var(--darkBlue);
                    }
                    .attachment {
                        color: var(--darkBlue);
                        font-size: 14px;
                        font-weight: 400;
                    }
                }

                .reactions-row {
                    position: absolute;
                    display: flex;
                    align-items: stretch;
                    justify-content: space-around;
                    align-self: flex-start;
                    gap: 37px;
                    top: 120px;
                    right: 30px;

                    .reaction-active {
                        color:var(--darkBlue);
                    }

                    .actived-reaction {
                        padding: 5px;
                        display: flex;
                        outline: 1px solid var(--darkBlue);
                        border-radius: 50%;
                        box-sizing: border-box;
                        width: 45px;
                        height: 45px;
                        align-content: center;
                        align-items: center;
                        justify-content: center;
                        background: var(--bodyColor2);
                    }
                    .unactive-reaction {
                        transition: 0.5s;
                        padding: 5px;
                        display: flex;
                        border-radius: 50%;
                        box-sizing: border-box;
                        width: 45px;
                        height: 45px;
                        align-content: center;
                        align-items: center;
                        justify-content: center;
                        background: var(--bodyColor2);
                    }

                    .reaction-wrapper {
                        transition: 0.5s;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        text-align: center;
                        justify-content: space-between;
                        color: var(--bodyColor2);
                        font-size: 10px;
                        font-weight: 400;
                        line-height: 140.625%;
                        white-space: normal;
                        max-width: 5ch;

                        .text-bot-active {
                            color:var(--darkBlue);
                            font-weight: 600;
                        }

                        .reaction-text-box {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            min-height: 32px;
                        }

                        img {
                            transition: 0.5s;
                            background: var(--bodyColor2);
                            min-height: 45px;
                            width: 31px;
                            cursor: pointer;
                            padding: 0px;
                            margin: 0;
                        }

                        .not-displayed {
                            height: 13.68px;
                            width: 100%;
                        }
                    }
                }

                .annoucement-subject {
                    font-weight: 600;
                    line-height: 140.625%;
                }

                .annoucement-content {
                    color: var(--text);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140.625%;
                }

            }

            .comments-title {
                margin-top: 140px;
                color: var(--text);
                font-size: 30px;
                font-weight: 700;
            }

            .page-line {
                border-bottom: 2px solid var(--borderGray);
                width: 100%;
                stroke-width: 2px;
                stroke: var(--borderGray);
                margin-top: 19px;
                margin-bottom: 30px;
            }

            .form-input-comment {
                position: relative;
                transition: margin-bottom 0.5s ease;
                .input-comment-wrapper {
                    transition: 0.5s;
                    display: flex;
                    justify-content: center;
                    background: var(--bodyColor2);
                    position: relative;
                    gap: 30px;

                    .input-comment-inside-wrapper {
                        width: 100%;
                        .textarea-comment-input {
                            transition: 0.5s;
                            cursor: pointer;
                            background: var(--leftMenuColor) !important;
                            width: 100%;
                            min-height: 52px;
                            padding: 15px;
                            align-items: center;
                            border-radius: 30px;
                            border: 1px solid var(--border);
                            overflow: hidden;
                            resize: none;
                            margin-right: 10px;
                            height: 22px;
                        }

                        .textarea-comment-input-active {
                            transition: 0.5s;
                            cursor: text;
                            color: var(--text) !important;
                            max-height: 90px;
                        }

                        .remaining-characters {
                            color: var(--text);
                            display: none;
                        }

                        .remaining-characters-active {
                            display: block;
                            position: absolute;
                            left: 105px;
                            font-size: 11px;
                        }

                        .send-comment-button {
                            transition: 0.5s;
                            position: absolute;
                            border-radius: 20px;
                            border: 5px solid var(--darkBlue);
                            background: var(--darkBlue);
                            color: #fff;
                            height: 33px;
                            width: 105px;
                            font-weight: 500;
                            opacity: 0;
                            transition: opacity 0.4s ease-in;
                            bottom: -40px;
                            right: 30px;
                        }

                        .send-comment-button-active {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            opacity: 1;
                            position: absolute;
                            right: 30px;
                        }

                        .input-comment-wrapper-active {
                            max-height: 100%;
                        }
                    }

                    img {
                        object-fit: cover;
                        width: 55px;
                        height: 55px;
                        border-radius: 55px;
                        flex: 0 0 auto;
                        border: 1px solid var(--border);
                    }

                    textarea {
                        height: auto;
                    }

                    textarea:focus {
                        outline: none !important;
                        border-color: var(--darkBlue);
                    }

                    textarea::placeholder {
                        color: var(--text);
                        font-size: 13px;
                        font-size: 400;
                    }
                }
            }

            .form-input-comment-active {
                margin-bottom: 55px;
            }
            .comment-wrapper {
                position: relative;
                display: flex;
                gap: 30px;

                .comment-box {
                    transition: 0.5s;
                    position: relative;
                    border-radius: 5px;
                    background: var(--leftMenuColor);
                    margin-top: 30px;
                    width: 100%;
                    height: 122px;
                    padding: 10px;
                    margin-bottom: 40px;
                    margin-right: 10px;
                    box-shadow: 1px 2px 7px 3px var(--border);
                    word-break: break-all;

                    .vector-comment-box{
                        transition: 0.5s;
                        content: "";
                        position: absolute;
                        height: 0;
                        width: 0;
                        border: 9px solid transparent;
                        border-right: 17px solid var(--leftMenuColor);
                        left: -24px;
                        top: 13px;
                    }
                }

                .comment-date {
                    color: var(--text);
                    position: absolute;
                    display: flex;
                    align-self: flex-end;
                    right: 53px;
                    bottom: 15px;
                    font-size: 11px;
                }
                .delete-button {
                    position: absolute;
                    right: 35px;
                    top: 159px;
                    height: 15px;
                    cursor: pointer;
                }

                .profile-img-ellipse {
                    object-fit: cover;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 56px;
                    height: 57px;
                    border-radius: 55px;
                    background: #d9d9d9;
                    color: #FFF;
                    font-size: 15.875px;
                    font-weight: 500;
                    flex: 0 0 auto;
                    margin-top: 30px;
                    border: 1px solid var(--border);
                }

                .profile-comment-username {
                    color: var(--darkBlue);
                    font-size: 15px;
                    font-weight: 500;
                }

                .profile-comment {
                    color: var(--text);
                    font-size: 13px;
                    font-weight: 500;
                    margin-top: 4px;
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/communication/communicationDetail.vue